import { render, staticRenderFns } from "./CompContestsContestGridCard.vue?vue&type=template&id=5b11cdde&scoped=true"
import script from "./CompContestsContestGridCard.vue?vue&type=script&setup=true&lang=js"
export * from "./CompContestsContestGridCard.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b11cdde",
  null
  
)

export default component.exports